import { MarkdownDisplay } from "@kanda-libs/ks-component-ts";
import { Text } from "@kanda-libs/ks-design-library";
import type { FunctionComponent } from "react";
import { CLASS_NAMES, TITLE } from "./constants";
import useJobNotesProps from "./useJobNotesProps";

export interface JobNotesProps {}

const JobNotes: FunctionComponent<JobNotesProps> = function () {
  const { notes = "" } = useJobNotesProps();

  if (!notes) {
    return <></>;
  }

  return (
    <div className={CLASS_NAMES.container}>
      <p className={CLASS_NAMES.title}>{TITLE}</p>
      <div className={CLASS_NAMES.content}>
        <Text
          className={CLASS_NAMES.description}
          text={<MarkdownDisplay>{notes}</MarkdownDisplay>}
        />
      </div>
    </div>
  );
};

export default JobNotes;
